<template>
    <div>
        <VueBotUI
            ref="botUI"
            class="chatbot-container"
            :messages="messageList"
            :options="botOptions"
            :bot-typing="isTyping"
            :is-open="isOpen"
            :bubble-btn-size="0"
            @init="isOpen = true"
            @msg-send="handleMessageReceived"
        >
            <template #bubbleButton>
                <button class="custom-chat-button" v-if="!isOpen">
                    <img src="@/assets/img/chatbot/gastrorankingIcon.svg" alt="Chat" />
                </button>
            </template>
            <template v-slot:header>
                <div class="chat-header pl-10 pr-4 " v-if="messageList.length === 0">
                  <div class="chat-logo d-flex justify-space-between  pb-2">
                    <img :src="headerLogo" alt="Chat"/>
                    <div class="pt-2">
                      <v-icon class="cursor-pointer" color="white" @click="closeChat" >mdi-close</v-icon>
                    </div>
                  </div>
                  <p class="white--text text-caption">
                    <translate>
                    ¡Hola! 👋  Soy tu asistente de GastroRanking.
                    Si tienes dudas sobre cómo usar la plataforma —por ejemplo, dónde encontrar tus informes,
                    cómo entender una gráfica o cómo descargar datos— puedo ayudarte en segundos.
                    ¿Qué quieres hacer hoy?
                    </translate>
                  </p>
                </div>
                <div v-else class="chat-header2 pl-12 pr-4">
                  <div class="chat-logo d-flex justify-space-between">
                    <img :src="headerLogo2" alt="Chat" class="pt-2"/>
                    <div class="pt-2">
                      <v-icon @click="closeChat" class="cursor-pointer" color="white" >mdi-close</v-icon>
                    </div>
                  </div>
                </div>
            </template>
            <template v-slot:sendButton>
                <button class="custom-chat-button">
                  <img :src="sendButton" alt="sendButton"/>
                </button>
            </template>
        </VueBotUI>
    </div>
  </template>

  <script>
  import { VueBotUI } from "vue-bot-ui";

  export default {
    name: "Chatbot",
    components: { VueBotUI },
    data() {
      return {
        messageList: [],
        socket: null,
        isTyping: false,
        partialResponse: "", // para ir construyendo el texto recibido
        headerLogo: require("@/assets/img/chatbot/chatHeaderLogo.svg"),
        headerLogo2: require("@/assets/img/chatbot/chatHeaderLogo2.svg"),
        sendButton: require("@/assets/img/chatbot/chatSendButton.svg"),
        isOpen: false,
        botOptions: {
          botTitle: "GastroRanking Assistant",
          textColor: "black",
          boardContentBg: "#f5f5f5",
          botAvatarSize: 40,
          botAvatarImg: require("@/assets/img/chatbot/gastrorankingIcon.svg"),
          msgBubbleBgBot: "#F1F0EE",
          msgBubbleColorBot: "#000000",
          msgBubbleBgUser: "#F9F8F4",
          msgBubbleColorUser: "black",
          inputPlaceholder: "Escribe aquí tu mensaje",
        },
      };
    },

    methods: {
      closeChat() {
        this.isOpen = false;
        console.log("this.$refs", this.$refs);
        this.$refs?.botUI?.botClose();
      },
      handleMessageReceived(message) {
        // Add user message to the list
        this.messageList.push({
          agent: "user",
          type: "text",
          text: message.text,
        });

        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
          // Send message to backend
          this.socket.send(message.text);
          this.isTyping = true;
          this.partialResponse = "";
        }
      },
      handleSocketMessage(event) {
        console.log("event", event);
        const data = JSON.parse(event.data);

        switch (data.type) {
          case "delta":
            // 🔹 Ir acumulando el texto parcial
            this.partialResponse += data.payload;
            // Keep typing indicator active
            this.isTyping = true;
            break;

          case "done":
            // 🔹 Finaliza el mensaje
            this.isTyping = false;
            if (this.partialResponse.trim() !== "") {
              this.messageList.push({
                agent: "bot",
                type: "text",
                text: this.partialResponse,
              });
            }
            this.partialResponse = "";
            break;

          case "error":
            // 🔹 Mostrar error
            this.isTyping = false;
            this.messageList.push({
              agent: "bot",
              type: "text",
              text: "Error al generar la respuesta: " + data.payload,
            });
            this.partialResponse = "";
            break;

          default:
            console.warn("Tipo de mensaje desconocido:", data.type);
        }
      },

      // 🛰️ Conectar el WebSocket
      connectWebSocket() {
        let url = `wss://assistant.gastroranking.com/bot`
        if (window.location.hostname === 'localhost') {
          url = `wss://assistant-stg.gastroranking.com/bot`
        }
        this.socket = new WebSocket(url);

        this.socket.onopen = () => {
          console.log("✅ WebSocket conectado");
        };

        this.socket.onmessage = this.handleSocketMessage;

        this.socket.onclose = () => {
          console.warn("⚠️ WebSocket cerrado. Reintentando...");
          setTimeout(this.connectWebSocket, 3000);
        };

        this.socket.onerror = (err) => {
          console.error("WebSocket error:", err);
        };
      },
    },

    created() {
      this.connectWebSocket();
    },
  };
  </script>

<style lang="scss">
.chatbot-container {
  .qkb-board {
    bottom: 7px;
    width: 400px;
    height: 500px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }
  .chat-header {
      width: 100%;
      height: 100%;
      background-image: url('~@/assets/img/chatbot/chatHeader.svg');

      .chat-logo {
        height: 77px;
      }

      img {
        width: 55%;
        height: auto;
      }
  }
  .qkb-board-header:has(.chat-header) {
    height: 220px;
  }

  .qkb-board-header:has(.chat-header2) {
    height: 109px;
  }

  .chat-header2 {
    width: 100%;
    height: 100%;
    background-image: url('~@/assets/img/chatbot/chatHeader2.svg');
  }

  .qkb-board-header {
    background-color: white!important;
    padding: 0;
  }

  .qkb-board-content {
    background-color: white!important;
  }

  .qkb-bubble-btn {
    background-color: transparent!important;
    box-shadow: unset;
    transform: scale(1);
    transition: transform 0.3s;
      &:hover {
        transform: scale(1.2);
      }
    .qkb-bubble-btn-icon {
      display: none;
    }
  }

  .qkb-board-action {
    height: 64px;
  }

  .qkb-action-item {
    opacity: 1;
  }

  .qkb-board-action__input {
    font-size: 14px;
    color: black;
    &::placeholder {
      color: black;
    }
  }

  .qkb-msg-bubble.qkb-msg-bubble--bot .qkb-msg-bubble-component {
    margin-left: 0;
    margin-right: 0;
  }

  .qkb-bubble-btn:not(:has(.custom-chat-button)) {
    display: none !important;
  }

}

</style>
